import React from 'react'
import { Link } from 'gatsby';
export default function AlreadySubscribedMessage() {
  const closeWhenGo = event => {
    event.preventDefault();
    $('#email').modal('hide');
  };
    return (
                 <div className="container  p-4">
                    <div className="section-title section-title-blue text-align-center">
                      <h6>You Are Already a Subscriber</h6>
                      <p>It looks like you’re already part of the BizDamn community.</p>
                      <p>In other words, you’re already awesome and don’t need to sign up again.</p>
                    </div>
                    <div className="justify-content">
                      <p>
                        If you’re looking for making Money Online and want to start a new Business.
                        <br />
                        These 2 can help:
                      </p>
                      <Link
                        to="/business-ideas"
                        onClick={() => closeWhenGo()}
                        mdb-toggle="tooltip"
                        title="This E-book contains 103 Online Business Ideas categorised into 7 major categories with all resources you need to get started"
                      >
                        E-Book #1: 103 Business Ideas
                      </Link>
                      <br />
                      <br />
                      <Link
                        onClick={() => closeWhenGo()}
                        to="/online-business-quickstart-checklist"
                        mdb-toggle="tooltip"
                        title="It will help you in excecuting your Business Idea to make it a great success"
                      >
                        Checklist #1: Online Business Quick Start Checklist
                      </Link>
                      <br />
                      <br />
                      Talk Soon,
                      <br />
                      Apoorva
                    </div>
                  </div>
    )
}
